<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h5"
              ><!--{{ files
              }}{{ currentFile }}-->{{ $t("documenti.titolo") }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="row">
                <div
                  v-for="(documento, index) in documenti"
                  :key="index"
                  class="
                    card card-nav-tabs
                    animate__animated animate__bounceInDown
                    col-lg-4 col-md-6 col-sm-12
                  "
                >
                  <h4
                    class="
                      card-header card-header-primary
                      font-weight-bold
                      grey
                      lighten-2
                      black--text
                      text--lighten-1
                      body-1
                      p-2
                    "
                  >
                    {{ documento.titolo[$i18n.locale] }}
                  </h4>
                  <v-card-subtitle>
                    <div v-html="documento.desc[$i18n.locale]"></div>
                  </v-card-subtitle>
                  <div class="card-body">
                    <h4 class="card-title">
                      <v-row>
                        <v-col
                          cols="12"
                          v-if="!checkFilePresente(documento.cod_documento)"
                        >
                          <v-file-input
                            ref="FileInputRef"
                            persistent-hint
                            :accept="documento.tipo"
                            :label="
                              $t('documenti.caricaFile', {
                                formato:
                                  documento.tipo == 'application/pdf'
                                    ? 'PDF'
                                    : 'JPEG',
                              })
                            "
                            :prepend-icon="documento.icona"
                            multiple
                            chips
                            color="pink"
                            @change="
                              aggiungiFile(
                                documento.cod_documento,
                                documento.tipo
                              )
                            "
                            v-model="currentFile"
                            :rules="
                              rulesFile(documento.cod_documento, documento.tipo)
                            "
                            :clearable="false"
                          ></v-file-input
                        ></v-col>

                        <v-col
                          cols="12"
                          v-if="checkFilePresente(documento.cod_documento)"
                          class="text-center"
                        >
                          <v-chip
                            class="ma-1"
                            large
                            color="primary"
                            text-color="white"
                            @click:close="cancellaFile(documento.cod_documento)"
                          >
                            <v-avatar left>
                              <v-icon
                                @click="
                                  apriViewer(getIdDoc(documento.cod_documento))
                                "
                                v-tooltip="$t('documenti.anteprima')"
                                >search</v-icon
                              >
                            </v-avatar>

                            <strong>{{ $t("documenti.fileCaricato") }}</strong>
                            <v-icon
                              right
                              @click="cancellaFile(documento.cod_documento)"
                              v-tooltip="$t('documenti.cancella')"
                            >
                              delete
                            </v-icon>
                            <!--{{ documentoStore(documento.cod_documento) }}-->
                          </v-chip>
                          <!-- {{ files.length }}
                          <v-avatar>
                         
                            <img
                              :ref="'file'"
                              src=""
                              class="img-fluid"
                              :title="'filegg'"
                            />
                          </v-avatar>-->
                        </v-col>
                      </v-row>
                    </h4>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer
              ><small>({{ $t("campiObbligatori") }})</small></v-spacer
            >
            <v-btn color="primary darken-1" @click="validazione">
              {{ $t("conferma") }}
            </v-btn>
            <v-btn color="primary darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogViewer" scrollable persistent max-width="900px">
      <v-card>
        <v-card-title class="text-h5"> Anteprima </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <vue-pdf-embed :source="pdfSource" />
          <center><img :src="imgSource" width="200" height="200" /></center>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" @click="dialogViewer = false">
            {{ $t("chiudi") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog foto-->
    <v-dialog v-model="dialogFoto" scrollable persistent max-width="1000px">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("documenti.foto") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-alert dense text type="info" color="primary">
          <strong
            ><b>
              {{ $t("documenti.istruzioniFoto") }}
            </b></strong
          >
        </v-alert>
        <v-card-text>
          <v-row>
            <v-col>
              <v-card class="pa-2" outlined tile
                ><center>
                  <cropper
                    :src="image.src"
                    @change="onChange"
                    class="cropper"
                    :auto-zoom="true"
                    :stencil-props="{
                      aspectRatio: 1,
                    }"
                  /></center></v-card
            ></v-col>
            <v-col>
              <v-card class="pa-2" outlined tile>
                <center>
                  <div class="text-h6">
                    {{ $t("documenti.anteprimaBadge") }}
                  </div>
                  <!--anteprima badge-->
                  <v-card
                    class="mx-auto"
                    max-width="360"
                    outlined
                    elevation="3"
                  >
                    <v-list-item three-line>
                      <v-list-item-content> </v-list-item-content>

                      <preview
                        class="ma-2"
                        :width="80"
                        :height="80"
                        :image="result.image"
                        :coordinates="result.coordinates"
                      />
                    </v-list-item>

                    <v-card-actions>
                      <p>
                        <br />{{ anagrafica.cognome }} {{ anagrafica.nome }}
                      </p>
                    </v-card-actions>
                    <v-system-bar height="30" color="primary"
                      ><v-spacer></v-spacer>
                      <div class="text-white font-weight-black">
                        STUDENTE
                      </div></v-system-bar
                    >
                  </v-card>
                  <!-- fine anteprima-->
                  <!--<preview
              :width="200"
              :height="200"
              :image="result.image"
              :coordinates="result.coordinates"
            />-->
                  <br />
                  <v-btn color="primary darken-1" @click="confermaFoto">
                    {{ $t("conferma") }}
                  </v-btn>
                </center></v-card
              ></v-col
            >
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" @click="chiudiDialogFoto">
            {{ $t("chiudi") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fine dialog foto-->
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      color="primary"
    >
      <b>{{ $t("checkCampiObbligatori") }}</b>
    </v-snackbar>
  </v-row>
</template>

<script>
import api from "@/services/EventService.js";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import { Cropper, Preview } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

//import funzioni from "@/assets/base64toFile.js";

function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

export default {
  name: "documenti",
  components: {
    VuePdfEmbed,
    Cropper,
    Preview,
  },
  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    dialogViewer: false,
    dialogFoto: false,
    pdfSource: "",
    imgSource: "",
    imgSourceAnteprima: "",
    documenti: [],
    dialog: true,
    anteprimaFoto: "",
    nuovoIdDoc: null,
    readers: [],
    currentFile: null,
    progress: 0,
    message: "",
    fileInfos: [],
    image: {
      src: null,
      type: null,
      inModifica: false,
      codice: null,
      tipo: null,
    },
    result: {
      coordinates: null,
      image: null,
      img64: null,
    },
  }),
  methods: {
    // gestione foto
    chiudiDialogFoto() {
      this.currentFile = null;
      this.dialogFoto = false;
    },

    onChange({ coordinates, canvas, image }) {
      this.result.coordinates = coordinates;
      this.result.image = image;
      this.result.img64 = canvas.toDataURL();
    },
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image, that can be used
      // as src for <img/> to preview result

      let nuovoFile = canvas.toDataURL();
      this.imgSourceAnteprima = nuovoFile;
    },
    async confermaFoto() {
      var block = this.result.img64.split(";");

      var realData = block[1].split(",")[1];
      await this.uploadFileFoto(this.image.codice, realData);
      this.files.push({ codice: this.image.codice, idDoc: this.nuovoIdDoc });
      // pulisco tutto
      this.nuovoIdDoc = 0;

      this.currentFile = null;
      this.dialogFoto = false;
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      // Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },
    destroyed() {
      // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.image.src) {
        URL.revokeObjectURL(this.image.src);
      }
    },
    // fine gestine foto

    caricaFoto() {
      this.dialogFoto = true;
    },

    apriViewer(idDoc) {
      // reset
      this.pdfSource = null;
      this.imgSource = null;
      //
      api
        .get(
          "/FileManager/" + idDoc
          //{
          //headers: { "Content-Type": "multipart/form-data" },
          // }
        )
        //.then((file)=> this.pdfSource='data:application/pdf;base64,'+file+'')
        .then(
          (file) => (
            (this.pdfSource = "data:application/pdf;base64," + file.data + ""),
            (this.imgSource = "data:image/jpeg;base64," + file.data + "")
          )
        )
        .catch((error) => alert(error));

      this.dialogViewer = true;
    },
    resetFileInput() {
      this.$refs.FileInputRef.reset();
    },
    rulesFile(codice, tipo) {
      var regole = [
        (value) =>
          !value ||
          !value.some((file) => file.size > 2e6) ||
          this.$t("documenti.fileTooBig"),
        (value) =>
          !value ||
          !value.some((file) => file.type != tipo) ||
          this.$t("documenti.fileErrato"),
      ];

      if (!this.checkFilePresente(codice)) {
        regole.push(
          (value) => !!value || this.$t("documenti.fileObbligatorio")
        );
      }

      return regole;
    },

    isRequired(value) {
      if (value) {
        return false;
      } else {
        return true;
      }
    },

    async chiudi() {
      if (!this.$refs.form.validate()) {
        await this.$store.dispatch("setStepNoCompletoEvent", 5);
      }
      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("setStepCompletoEvent", 5);
        this.attivo = false;
      } else {
        this.snackbar = true;
      }
    },

    carica_elenco_documenti() {
      let cittadinanza = this.anagrafica.cittadinanza1.CODICENU;
      let statoCivile = this.anagrafica.statoCivile.CODICENU;
      let facolta = this.iscrizione_store.dati.fac_scelta.CODICENU;
      let corsolaurea = this.iscrizione_store.dati.ciclo_scelto.CODICENU;

      api
        .get(
          "/documenti/immatricolazione/" +
            cittadinanza +
            "/" +
            statoCivile +
            "/" +
            facolta +
            "/" +
            corsolaurea +
            ""
        )
        .then((r) => {
          this.documenti = r.data;
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();
    },
    async aggiungiFileFoto(img64) {
      var block = img64.split(";");
      // Get the content type
      //var contentType = block[0].split(":")[1];// In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1];
      alert(realData);
      await this.uploadFileFoto(32, realData);

      //this.files.push({ codice: img64, idDoc: this.nuovoIdDoc });

      // reset idDoc
      this.nuovoIdDoc = 0;
    },
    async uploadFileFoto(codice, img64) {
      let nuovoIDdoc = 0;
      const formData = new FormData();
      formData.append("img64", img64);
      formData.append("codice_doc", codice);
      formData.append(
        "facolta",
        this.iscrizione_store.dati.fac_scelta.CODICENU
      );
      formData.append(
        "corsolaurea",
        this.iscrizione_store.dati.ciclo_scelto.CODICENU
      );
      formData.append("prematricola", this.parametri_store.prematricola);
      formData.append("annoaccademico", this.parametri_store.annoaccademico);
      formData.append("annocorso", this.iscrizione_store.dati.anno_scelto);

      await api
        .post("FileManager", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => (this.nuovoIdDoc = r.data))
        .catch((error) => alert(error));

      return nuovoIDdoc;
    },
    async aggiungiFile(codice, tipo) {
      // se si tratta di una immagine apro la finestra per editarla (fototessera)

      if (tipo == "image/jpeg") {
        for (let file of this.currentFile) {
          const data = URL.createObjectURL(file);

          this.image.src = data;
          this.image.inModifica = true;
          this.image.codice = codice;
          this.image.tipo = tipo;
          this.dialogFoto = true;
          return;
        }
      }

      // upload del file

      for (let file of this.currentFile) {
        if (file.type == tipo) {
          await this.uploadFile(codice, file);

          this.files.push({ codice: codice, idDoc: this.nuovoIdDoc });

          // reset idDoc
          this.nuovoIdDoc = 0;
        } else {
          alert("formato errato:" + tipo);
        }
      }

      // pulisco tutto
      this.currentFile = null;
    },

    async uploadFile(codice, file) {
      //alert(codice + "-" + file.size);
      let nuovoIDdoc = 0;
      const formData = new FormData();
      formData.append("FormFile", file);
      formData.append("codice_doc", codice);
      formData.append(
        "facolta",
        this.iscrizione_store.dati.fac_scelta.CODICENU
      );
      formData.append(
        "corsolaurea",
        this.iscrizione_store.dati.ciclo_scelto.CODICENU
      );
      formData.append("prematricola", this.parametri_store.prematricola);
      formData.append("annoaccademico", this.parametri_store.annoaccademico);
      formData.append("annocorso", this.iscrizione_store.dati.anno_scelto);
      await api
        .post("FileManager", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => (this.nuovoIdDoc = r.data))
        .catch((error) => alert(error));

      return nuovoIDdoc;
    },

    cancellaFile(codice) {
      const delDocumento = this.files.findIndex((h) => h.codice === codice);

      this.files.splice(delDocumento, 1);
    },
    documentoStore(codice) {
      let varFile = this.files.findIndex((h) => h.codice === codice);
      let bodonzo = this.files[varFile];
      return codice + "@" + JSON.stringify(bodonzo);
    },
    checkFilePresente(codice) {
      let varFile = this.files.findIndex((h) => h.codice === codice);

      if (varFile != -1) {
        return true;
      } else {
        return false;
      }
    },
    getIdDoc(codice) {
      let varFile = this.files.findIndex((h) => h.codice === codice);

      if (varFile != -1) {
        return this.files[varFile].idDoc;
      }
    },
    Preview_image(event) {
      alert(JSON.stringify(event));
      /* console.log("files", this.files);
      this.files.forEach((file, f) => {
        this.readers[f] = new FileReader();
        this.readers[f].onloadend = () => {
          let fileData = this.readers[f].result;
          let imgRef = this.$refs.file[f];

          imgRef.src = fileData;
          console.log(fileData);
          // send to server here...
        };

        this.readers[f].readAsDataURL(this.files[f]);
      });*/
      /*if (e) {
        this.anteprimaFoto = URL.createObjectURL(e);
        this.anagrafica.fototessera = J
      } else{
         this.anteprimaFoto = ""
      }*/
    },
  },
  mounted() {
    this.carica_elenco_documenti();
  },
  activated() {
    this.carica_elenco_documenti();
  },

  computed: {
    files() {
      return this.$store.state.documenti.folder;
    },
    anagrafica() {
      return this.$store.state.anagrafica;
    },
    iscrizione_store() {
      return this.$store.state.iscrizione;
    },
    parametri_store() {
      return this.$store.state.parametri;
    },
  },
};
</script>

<style scope>
.cropper {
  height: 400px;
  width: 400px;
  background: #ddd;
}
</style>
